import empty from '@/assets/empty.png';
import { Empty, EmptyProps } from 'antd';

export default function CommonEmpty(props: EmptyProps) {
  // lighthouse 优化, 添加alt属性
  return <Empty image={<img src={empty} alt='Empty' />} imageStyle={{ height: 64 }} {...props} />;
}
